/**
 * 字段类型
 */
export var FieldType;
(function (FieldType) {
    /**
     * 字符串
     */
    FieldType[FieldType["String"] = 1] = "String";
    /**
     * 数值型
     */
    FieldType[FieldType["Number"] = 2] = "Number";
})(FieldType || (FieldType = {}));
/**
 * 字段
 * @remarks
 * TODO: a lot of things to be done
 */
export class Field {
    /**
     * 构造函数
     * @param {string} name - 字段名称
     * @param {FieldType} type - 字段类型
     */
    constructor(name, type) {
        this.name = name;
        this.type = type;
    }
}
